import { Alert } from "@/components/Alert"
import { CardDetailsActions } from "@/components/Cards/View/Details/Actions"
import { CardDetailsDetails } from "@/components/Cards/View/Details/Details"
import { CardDetailsHeader } from "@/components/Cards/View/Details/Header"
import { CardDetailsSensitive } from "@/components/Cards/View/Details/Sensitive"
import { ECardType, useStoreCardView } from "@usher/pe-client-front-end-lib"
import { useMemo } from "react"
import { FormattedMessage } from "react-intl"
import { DetailsRow } from "../../Create/Expense/card-details/DetailsRow"
import { Activation } from "./Activate"
import { CardDetailsCard } from "./Card"
import "./style.sass"

export const CardDetails = () => {
  const { type, status, isVertex, id, fx_fee, decline_fee, ...card } = useStoreCardView((state) => state.card)
  const supportText = useMemo(() => {
    let text: string[] = []
    if (card?.apple_pay === "1") text.push("Apple Pay")
    if (card?.google_pay === "1") text.push("Google Pay")
    if (text.length === 0) return "Not Supported"
    return `${text.join(" & ")} Supported`
  }, [card])
  return (
    <div className="main-content_one-card">
      <CardDetailsHeader />
      {!isVertex && (
        <Alert size="sm" color="blue" severity="info">
          <FormattedMessage
            id="card_attempts"
            values={{
              b: (chunk) => <b>{chunk}</b>,
            }}
            tagName="p"
          />
        </Alert>
      )}
      {!isVertex && <CardDetailsActions />}

      {(status as string).toLowerCase().includes("not") && Number(type) === ECardType.Physical && <Activation card_id={Number(id)} />}
      <div className="block-one-card">
        <CardDetailsCard />
        <div className="block-one-card_info">
          <CardDetailsDetails />
          <CardDetailsSensitive />
        </div>
      </div>
      <div className="border bg-gray-100/50 px-4 py-3 col-span-2 mb-2">
        <div className="flex gap-2 mb-4">
          <div className="w-5 h-5 min-w-5 bg-blue-800 text-white grid place-items-center rounded-full font-bold">!</div>
          <strong className="text-sm">Card Details</strong>
        </div>
        <div className="flex flex-col gap-2.5 mb-3 border-b border-b-gray-200 pb-3">
          <DetailsRow title="Brand:">{card?.card_brand || "N/A"}</DetailsRow>
          <DetailsRow title="Country:">{card?.card_country || "N/A"}</DetailsRow>
          <DetailsRow title="Type:">{card?.card_type || "N/A"}</DetailsRow>
          <DetailsRow title="Currency:">{card?.card_currency || card?.currency}</DetailsRow>
        </div>

        <div className="flex flex-col gap-2.5">
          <DetailsRow title="Top Up Fee:">{card?.topup_fee || 0}</DetailsRow>
          <DetailsRow title="Transaction Fee:">{card?.transaction_fee}</DetailsRow>
          <DetailsRow title="FX Fee:">{card?.fx}</DetailsRow>
          {/*@ts-ignore*/}
          <DetailsRow title="Decline Fee:">{card?.decline_fee}</DetailsRow>
          <DetailsRow title="Small Transaction Fee:">{card?.small_tr_fee}</DetailsRow>
          <DetailsRow title="3DS Support:">{card?.["3ds_support"] || "Not Supported"}</DetailsRow>
          <DetailsRow title="Apple/Google Pay:">{supportText}</DetailsRow>
        </div>
        {card?.info && <span className="block mt-3 text-blue-800 font-bold text-sm">Recommended use: {card.info}</span>}
      </div>
      {/* <div className="main-content_one-card_title">
        <FormattedMessage id="card-limits" />
      </div> */}
      {/* <CardDetailsLimits /> */}
    </div>
  )
}
